/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

import { h as helper } from '../../_chunks/dep-115a1bd3.js';
import EditableCell from '../editable-cell.js';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/typeof';
import '@babel/runtime/helpers/defineProperty';
import '@vue/composition-api';
import 'lodash/get';
import 'lodash/set';
import 'lodash/isFunction';
import 'tdesign-icons-vue';
import '../../hooks/useGlobalIcon.js';
import '../../hooks/useConfig.js';
import '../../config-provider/useConfig.js';
import '../../config-provider/context.js';
import 'lodash/merge';
import 'lodash/mergeWith';
import '../../_common/js/global-config/default-config.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import '../../config-provider/type.js';
import '../tr.js';
import 'lodash/upperFirst';
import 'lodash/isString';
import 'lodash/pick';
import '../utils.js';
import 'lodash/isObject';
import './useFixed.js';
import '@babel/runtime/helpers/slicedToArray';
import 'lodash/debounce';
import '../../_common/js/log/index.js';
import '../../_common/js/log/log.js';
import '../../_common/js/utils/getScrollbarWidth.js';
import '../../_common/js/utils/helper.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '../../utils/dom.js';
import 'vue';
import 'raf';
import '../../utils/easing.js';
import './useClassName.js';
import '../ellipsis.js';
import '../../utils/render-tnode.js';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../../tooltip/index.js';
import '../../tooltip/tooltip.js';
import '../../tooltip/props.js';
import '../../popup/props.js';
import '../../popup/popup.js';
import '@popperjs/core';
import '../../utils/helper.js';
import '../../_common/js/utils/set-style.js';
import '../../popup/container.js';
import '../../config-provider/config-receiver.js';
import '../../utils/mixins.js';
import '../../utils/map-props.js';
import '../../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../../tooltip/type.js';
import '../base-table-props.js';
import './useRowspanAndColspan.js';
import '../../hooks/useLazyLoad.js';
import '../../_common/js/utils/observe.js';
import '../../form/form-model.js';
import '@babel/runtime/helpers/asyncToGenerator';
import '@babel/runtime/regenerator';
import '../../_chunks/dep-8d1f65ff.js';
import 'lodash/isEmpty';
import 'lodash/isNumber';

function useEditableCell(props, context) {
  var renderEditableCell = function renderEditableCell(h, p) {
    return h(EditableCell, helper([{}, {
      "props": p
    }, {
      "scopedSlots": context.slots
    }]));
  };

  return {
    renderEditableCell: renderEditableCell
  };
}

export { useEditableCell as default };
//# sourceMappingURL=useEditableCell.js.map
